import { useCallback, useEffect, useMemo, useState } from 'react'

import { ReduxService } from 'dashboard-services/services'

import groupConfigService from '../groupConfigService'
import groupDialogService from '../groupDialogService'
import useGroupConfigFilesModule from './useGroupConfigFiles'
import useValidatorTaskModule from './useValidatorTask'

export default (() => {
  const { useGroupConfigFiles } = useGroupConfigFilesModule
  const { useValidatorTask } = useValidatorTaskModule
  const EMPTY_ARRAY = []
  const EMPTY_OBJ = {}
  // isRestrictFileTypesOn stays undefined until toggled, so it follows the loaded file types
  const INITIAL_VALIDATION_OPTIONS = { isRestrictFileTypesOn: undefined, shouldRemoveInvalidParams: false }

  const usePriority = ({ initialFields }) => {
    const [priority, setPriority] = useState(() => initialFields ? groupDialogService.getDefaultPriority({ fields: initialFields }) : undefined),
          [initialPriority, setInitialPriority] = useState(priority)

    useEffect(() => {
      if(initialPriority === undefined && initialFields) {
        const loadedPriority = groupDialogService.getDefaultPriority({ fields: initialFields })
        setPriority(loadedPriority)
        setInitialPriority(loadedPriority)
      }
    }, [initialFields, initialPriority])

    return { priority, initialPriority, setPriority }
  }

  const useGroupDialogAdvanced = ({ isCreate, groupName, initialFields, isEnabled = true }) => {
    const { isLoaded, groupConfig, setGroupConfig, loadedGroupConfig, dynamicValidation, setDynamicValidation, dynamicValidationFileContent } = useGroupConfigFiles({ isCreate, groupName, enabled: isEnabled }),
          { isValidationEnabled, isDynamicValidationEnabled, filesConfigs = EMPTY_ARRAY } = groupConfig || EMPTY_OBJ,
          isDynamicValidationOn = !!isValidationEnabled && !!isDynamicValidationEnabled,

          { priority, initialPriority, setPriority } = usePriority({ initialFields }),
          [validationOptionsState, setValidationOptions] = useState(INITIAL_VALIDATION_OPTIONS),
          validationOptions = useMemo(() => ReduxService.updateObject(validationOptionsState, {
            isRestrictFileTypesOn: validationOptionsState.isRestrictFileTypesOn ?? filesConfigs.length > 0
          }), [filesConfigs.length, validationOptionsState]),

          validatorTask = useValidatorTask({ dynamicValidation, dynamicValidationFileContent, isEnabled: isDynamicValidationOn }),

          onChangeValidationOptions = useCallback((value, { name }) => {
            setValidationOptions(options => ReduxService.updateObject(options, { [name]: value }))
            name === "isRestrictFileTypesOn" && !value && setGroupConfig(config => ReduxService.updateObject(config, {
              filesConfigs: groupConfigService.setSelectedFileTypes({ filesConfigs: config.filesConfigs, fileTypes: EMPTY_ARRAY })
            }))
          }, [setGroupConfig])

    return useMemo(() => ({
      isLoaded,
      priority,
      initialPriority,
      groupConfig,
      setGroupConfig,
      loadedGroupConfig,
      dynamicValidation,
      setDynamicValidation,
      dynamicValidationFileContent,
      validationOptions,
      validatorTask,
      onChangePriority: setPriority,
      onChangeValidationOptions
    }), [dynamicValidation, dynamicValidationFileContent, groupConfig, initialPriority, isLoaded, loadedGroupConfig, onChangeValidationOptions, priority, setDynamicValidation, setGroupConfig, setPriority, validationOptions, validatorTask])
  }

  return {
    useGroupDialogAdvanced
  }
})()
